import { AnyType } from './any.js';
export class ImmutableClassType extends AnyType {
    create() {
        if (this.isClass(this.type))
            return new this.type();
        else
            return new (this.type())();
    }
    isClass(func) {
        return typeof func === 'function' && /^class\s/.test(Function.prototype.toString.call(func));
    }
    convert(next) {
        if (next == null)
            return next;
        if (this.isClass(this.type) && next instanceof this.type)
            return next;
        if (this.isClass(this.type))
            return new this.type(next);
        else if (typeof this.type == 'function' && this.type.name == 'BigInt')
            return this.type(next);
        else if (next instanceof this.type())
            return next;
        else
            return new (this.type())(next);
    }
    toJSON(value, key, options) {
        return value && value.toJSON ? value.toJSON(options) : value;
    }
    clone(value) {
        if (this.isClass(this.type))
            return new this.type(this.toJSON(value));
        else
            return new (this.type())(this.toJSON(value));
    }
    isChanged(a, b) {
        return a !== b;
    }
}
export class PrimitiveType extends AnyType {
    dispose() { }
    create() { return this.type(); }
    toJSON(value) { return value; }
    convert(next) { return next == null ? next : this.type(next); }
    isChanged(a, b) { return a !== b; }
    clone(value) { return value; }
    doInit(value, record, options) {
        return this.transform(value === void 0 ? this.value : value, void 0, record, options);
    }
    doUpdate(value, record, options, nested) {
        const { name } = this, { attributes } = record, prev = attributes[name];
        return prev !== (attributes[name] = this.transform(value, prev, record, options));
    }
    initialize() {
        if (!this.options.hasCustomDefault) {
            this.value = this.type();
        }
    }
}
export class NumericType extends PrimitiveType {
    create() {
        return 0;
    }
    convert(next, prev, record, options) {
        const num = next == null ? next : this.type(next);
        if (num !== num) {
            this._log('error', 'Type-R:InvalidNumber', 'Number attribute is assigned with an invalid number', next, record, options.logger);
        }
        return num;
    }
    validate(model, value, name) {
        if (value != null && !isFinite(value)) {
            return name + ' is not valid number';
        }
    }
}
export class ArrayType extends AnyType {
    toJSON(value) { return value; }
    dispose() { }
    create() { return []; }
    convert(next, prev, record, options) {
        if (next == null || Array.isArray(next))
            return next;
        this._log('error', 'Type-R:InvalidArray', 'Array attribute assigned with non-array value', next, record, options.logger);
        return [];
    }
    clone(value) {
        return value && value.slice();
    }
}
export class ObjectType extends AnyType {
    create() { return {}; }
    convert(next, prev, record, options) {
        if (next == null || typeof next === 'object')
            return next;
        this._log('error', 'Type-R:InvalidObject', 'Object attribute is assigned with non-object value', next, record, options.logger);
        return {};
    }
}
export function doNothing() { }
export class FunctionType extends AnyType {
    toJSON(value) { return void 0; }
    create() { return doNothing; }
    dispose() { }
    convert(next, prev, record, options) {
        if (next == null || typeof next === 'function')
            return next;
        this._log('error', 'Type-R:InvalidFunction', 'Function attribute assigned with non-function value', next, record, options.logger);
        return doNothing;
    }
    clone(value) { return value; }
}
//# sourceMappingURL=basic.js.map